import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { first, map, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private afAuth: AngularFireAuth
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Use AngularFireAuth's authState directly to get the real-time auth state
    // This waits for Firebase to restore the session on page reload
    return this.afAuth.authState.pipe(
      // Wait for Firebase to initialize and emit auth state (max 3 seconds)
      timeout(3000),
      first(),
      map((user) => {
        if (user) {
          return true;
        } else {
          return this.router.createUrlTree(['/auth/sign-in']);
        }
      })
    );
  }
}
